import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "364.442",
  height: "351.112",
  viewBox: "0 0 364.442 351.112"
}
const _hoisted_2 = {
  id: "liti",
  transform: "translate(-328.436 -147)"
}
const _hoisted_3 = ["stroke"]
const _hoisted_4 = {
  id: "多边形_122",
  "data-name": "多边形 122",
  transform: "translate(450.287 147) rotate(30)",
  fill: "none"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M210.089,0l70.03,121.851L210.089,243.7H70.03L0,121.851,70.03,0Z",
  stroke: "none"
}, null, -1)
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  id: "路径_5160",
  "data-name": "路径 5160",
  d: "M203.865,383.048l-71.818-39.467a5.379,5.379,0,0,1,0-9.434L203.865,293.9l71.818,40.246a5.379,5.379,0,0,1,0,9.434Z",
  transform: "translate(306.918 -59.492)",
  fill: "#e5e5e5",
  stroke: "#fff",
  "stroke-miterlimit": "10",
  "stroke-width": "1",
  opacity: "0.274"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  id: "路径_5161",
  "data-name": "路径 5161",
  d: "M-2041.126-7601.93v-85.458",
  transform: "translate(2551.781 8010.883)",
  fill: "none",
  stroke: "#fff",
  "stroke-width": "1",
  opacity: "0.359"
}, null, -1)

import { withDefaults } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'svg-2',
  props: {
    controlColor: { default: 'var(--theme-color-1, #000)' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        id: "路径_5159",
        "data-name": "路径 5159",
        d: "M218.331,400.332l-85.742-47.119a6.422,6.422,0,0,1,0-11.263L218.331,293.9l85.742,48.048a6.422,6.422,0,0,1,0,11.263Z",
        transform: "translate(292.451 17.264)",
        fill: "none",
        stroke: _ctx.controlColor,
        "stroke-miterlimit": "10",
        "stroke-width": "1"
      }, null, 8, _hoisted_3),
      _createElementVNode("g", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("path", {
          d: "M 70.6085205078125 0.9999847412109375 L 1.15338134765625 121.8511657714844 L 70.60847473144531 242.7023468017578 L 209.5108032226562 242.7023468017578 L 278.9659118652344 121.8511657714844 L 209.5108032226562 0.9999847412109375 L 70.6085205078125 0.9999847412109375 M 70.02986145019531 -1.52587890625e-05 L 210.0894775390625 -1.52587890625e-05 L 280.1192932128906 121.8511657714844 L 210.0894775390625 243.7023468017578 L 70.02983093261719 243.7023468017578 L 0 121.8511657714844 L 70.02986145019531 -1.52587890625e-05 Z",
          stroke: "none",
          fill: _ctx.controlColor
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("path", {
        id: "多边形_123",
        "data-name": "多边形 123",
        d: "M129.028,0l43.009,74.882-43.009,74.882H43.009L0,74.882,43.009,0Z",
        transform: "translate(473.666 214.883) rotate(30)",
        fill: _ctx.controlColor
      }, null, 8, _hoisted_7),
      _hoisted_8,
      _hoisted_9
    ])
  ]))
}
}

})